import React from 'react';

import moment from 'moment';
import { array, object, oneOfType, string } from 'prop-types';

import { Expression } from '@philips-emr/tws-constants';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, key, mobile } from '@philips-emr/tws-utils';

import { getWeekDays } from '../calendar-util';

function Weekday({ children, className }) {
  return <div className={className}>{children}</div>;
}

Weekday.propTypes = {
  children: oneOfType([string, array]),
  className: string,
};

function DesktopWeeklyWeekdays({ date }) {
  const weekdays = [
    <Weekday key={key('c-calendar-weekday')}>{msg(Expression.HOUR)}</Weekday>,
  ];

  const today = moment.utc();

  const weekDate = moment.utc(date).startOf('week');

  getWeekDays().forEach((weekday) => {
    const weekdayClasses = {
      today: weekDate.isSame(today, 'date'),
    };

    weekdays.push(
      <Weekday
        key={key('c-calendar-weekday')}
        className={classNames(weekdayClasses)}
      >
        {weekDate.date()} - {weekday}
      </Weekday>
    );

    weekDate.add(1, 'day');
  });

  return weekdays;
}

DesktopWeeklyWeekdays.propTypes = {
  date: oneOfType([string, object]),
};

function MobileWeeklyWeekdays({ date }) {
  const today = moment.utc();
  const weekDate = moment.utc(date).startOf('week');

  const weekdays = [<Weekday key={key('c-calendar-weekday')} />];

  getWeekDays(true).forEach((weekday) => {
    const weekdayClasses = {
      today: weekDate.isSame(today, 'date'),
    };

    weekdays.push(
      <Weekday
        key={key('c-calendar-weekday')}
        className={classNames(weekdayClasses)}
      >
        <span>{weekDate.format('DD')}</span>
        <span>{weekday}</span>
      </Weekday>
    );

    weekDate.add(1, 'day');
  });

  return weekdays;
}

MobileWeeklyWeekdays.propTypes = {
  date: oneOfType([string, object]),
};

function WeeklyWeekdays({ date }) {
  if (mobile.isMobile()) {
    return <MobileWeeklyWeekdays date={date} />;
  }

  return <DesktopWeeklyWeekdays date={date} />;
}

WeeklyWeekdays.propTypes = {
  date: oneOfType([string, object]),
};

export default WeeklyWeekdays;
